export const selectionStateSelector = ({ agGrid }) => agGrid.agSelectionState;
export const rowSelectionStateSelector = ({ agGrid }) => agGrid.agRowSelectionState;
